import React from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap"; 

const DDIIcon = ({ value }) => {
  const { t } = useTranslation();

  const getIconClass = (val) => {
    switch (val) {
      case 0:
        return "bi-diamond-fill";
      case 1:
        return "bi-triangle-fill";
      case 2:
        return "bi-square-fill";
      case 3:
        return "bi-pentagon-fill";
      case 4:
        return "bi-circle-fill";
      default:
        return "bi-circle-fill";
    }
  };

  const getTooltipKey = (val) => {
    switch (val) {
      case 0:
        return "auto.interacaoNaoEsperada";
      case 1:
        return "auto.interacaoPotencialFraca";
      case 2:
        return "auto.interacaoPotencialForte";
      case 3:
        return "auto.interacaoPotencialForteComAjusteDose";
      case 4:
        return "auto.naoCoadministrar";
      default:
        return "";
    }
  };

  const renderIcon = (val, dose) => (
    <OverlayTrigger
      popperConfig={{ modifiers: { preventOverflow: { enabled: "false" } } }}
      overlay={
        <Tooltip style={{ position: "fixed" }}>
          {dose ? `${dose}mg: ` : ""}
          {t(getTooltipKey(val))}
        </Tooltip>
      }
    >
      <span>
        <i className={"bi " + getIconClass(val) + " ddi-score-" + val} />
      </span>
    </OverlayTrigger>
  );

  // if the data value is a number, render the corresponding icon
  if (typeof value === "number") {
    return renderIcon(value);
  }

  // if the data value is an object, check if all values are the same
  if (typeof value === "object" && value !== null) {
    const values = Object.entries(value);
    const allSame = values.every(([, v]) => v === values[0][1]);

    // if all values are the same, render a single icon
    if (allSame) {
      return renderIcon(values[0][1]);
    }

    // if values differ, render each with its corresponding dose/tooltip
    return (
      <>
        {values.map(([dose, val], index) => (
          <span key={dose}>
            {renderIcon(val, dose)}
            {index < values.length - 1 && "  "}
          </span>
        ))}
      </>
    );
  }

  return null;
};

export default DDIIcon;
